"use client";

import { useState } from "react";
import NigoDisclaimer from "./NigoDisclaimer";
import NigoForm from "./NigoForm";
import NigoSummary from "./NigoSummary";
import type { NigoFlags } from "./types";

interface NigoContentProps {
  flags: NigoFlags;
  userId: string;
  userName: string;
}

export default function NigoContent({
  flags,
  userId,
  userName,
}: NigoContentProps) {
  const [completed, setCompleted] = useState(false);

  return (
    <>
      <div className="flex flex-col gap-2">
        <p className="font-medium text-lg">{userName}</p>
        <NigoDisclaimer />
        <NigoSummary completed={completed} flags={flags} />
      </div>
      <NigoForm
        flags={flags}
        onSubmitted={() => setCompleted(true)}
        userId={userId}
      />
    </>
  );
}
